/*
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2024-08-16 16:48:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-16 16:52:29
 */
/*
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2022-10-13 15:49:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-02-19 15:20:52
 */
const getters = {
    // sidebar: state => state.app.sidebar,
    // size: state => state.app.size,
    // device: state => state.app.device,
    // visitedViews: state => state.tagsView.visitedViews,
    // cachedViews: state => state.tagsView.cachedViews,
    // token: state => state.user.token,
    // avatar: state => state.user.avatar,
    // name: state => state.user.name,
    // introduction: state => state.user.introduction,
    // roles: state => state.user.roles,
    // permission_routes: state => state.permission.routes,
    // errorLogs: state => state.errorLog.logs,
    // next: state => state.next,
    // loginFlag: state => state.loginFlag,
    // credits: state => state.credits,
    // userName: state => state.userName
  }
  export default getters
  